import {
  AccountInfoResult,
  AuctionManagerEntryPoint,
  Deploy,
} from '@block-explorer/entities';

import { MessageData } from './types';
import { deriveAccountInfo } from '../../utils/account';

const prepareActionMessageData = (
  deploy: Deploy,
  getAccountInfo: <T>(hash: string) => T | null | undefined,
  t
): MessageData => {
  const { entryPoint, args } = deploy;
  const entryPointName = entryPoint?.name || '';

  const actionName: Record<AuctionManagerEntryPoint, string> = {
    [AuctionManagerEntryPoint.add]: t('Add bid'),
    [AuctionManagerEntryPoint.withdraw]: t('Withdraw bid'),
    [AuctionManagerEntryPoint.activate]: t('Activate bid'),
    [AuctionManagerEntryPoint.delegate]: t('Delegate'),
    [AuctionManagerEntryPoint.undelegate]: t('Undelegate'),
    [AuctionManagerEntryPoint.redelegate]: t('Redelegate'),
  };

  const prefix = entryPointName === 'delegate' ? t('to') : t('from');
  const validatorInfo = getAccountInfo<AccountInfoResult>(
    args?.validator?.parsed as string
  );
  const newValidatorInfo = getAccountInfo<AccountInfoResult>(
    args?.new_validator?.parsed as string
  );

  const validatorInfoDetails =
    validatorInfo &&
    deriveAccountInfo(
      validatorInfo?.account_info || validatorInfo?.centralized_account_info
    );
  const newValidatorInfoDetails =
    newValidatorInfo &&
    deriveAccountInfo(
      newValidatorInfo?.account_info ||
        newValidatorInfo?.centralized_account_info
    );

  const actionOutcome: Partial<MessageData> = {
    prefix1: prefix,
    account1: {
      publicKey: args?.validator?.parsed as string,
      logo: validatorInfoDetails?.logo || undefined,
      ...validatorInfo,
    },
    prefix2: args?.new_validator ? t('to') : '',
    account2: {
      publicKey: args?.new_validator?.parsed as string,
      logo: newValidatorInfoDetails?.logo || undefined,
      ...newValidatorInfo,
    },
  };

  return {
    entryPointName: entryPointName,
    actionName: actionName[entryPointName] || entryPointName,
    ...actionOutcome,
  };
};

export const auctionMessage = () => {
  const getRelevantAccountHashesFromArgs = () => {
    return ['validator', 'new_validator'];
  };

  return {
    prepareActionMessageData,
    getRelevantAccountHashesFromArgs,
  };
};
